import styled from 'styled-components'

export const Icon = styled.i`
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    transition: 4s;
`

interface BProps {
    status: 'published' | 'unpublished'
    disabled: boolean
}
export const Button = styled.button<BProps>`
    position: relative;
    margin-left: -5px;
    background-color: transparent;
    font-style: normal;
    font-weight: 600;
    font-size: 13px;
    line-height: 16px;
    width: auto;
    height: 24px;
    border-radius: 3px;
    border: 0;
    color: ${props => (props.status === 'published' ? '#01C292' : '#008AC7')};
    &:hover {
        background-color: ${props => (props.status === 'published' ? 'transparent' : props.theme['gray-200'])};
    }
`
